import { FC } from 'react'
import { IFundsOrigin } from '../../../../common/interfaces'

interface IProps {
  fundsOrigins: IFundsOrigin[]
  value: number | ''
  onChange: (fundsOriginId: number | '') => void
  loading?: boolean
}

export const FundOriginSelect: FC<IProps> = ({ fundsOrigins, value, onChange, loading }) => (
  <div className='col-lg-6 mb-7'>
    <label htmlFor='fundOrigin' className='text-muted fs-6 mb-2 d-flex align-items-center gap-2'>
      Origen de fondos
      {loading && <span className='spinner-border spinner-border-sm text-primary' role='status' />}
    </label>
    <select
      id='fundOrigin'
      className='selectForm contract-select-toggle'
      value={value}
      disabled={loading}
      onChange={(e) => onChange(e.target.value === '' ? '' : Number(e.target.value))}
    >
      <option value=''>Seleccione</option>
      {fundsOrigins.map((fundsOrigin) => (
        <option key={fundsOrigin.id} value={fundsOrigin.id}>
          {fundsOrigin.description}
        </option>
      ))}
    </select>
  </div>
)
